import type { profile as en } from '@/i18n/locales/en/profile';
import type { Translation } from '@/i18n/types';

export const profile: Translation<typeof en> = {
  title: 'Profil',
  lead: 'Adınız, diliniz ve gizlilik ayarlarınız.',
  pendingBadge: '{{count}} bekleyen rıza talebi',
  nav: {
    label: 'Profil menüsü',
    profile: 'Profil',
    consents: 'Rızalar',
    preferences: 'Tercihler',
    subscription: 'Abonelik',
  },
  preferredLanguage: 'Tercih edilen dil',
  preferredLanguageOptional: 'Tercih edilen dil (isteğe bağlı)',
  preferredLanguageUnset: 'Ayarlanmadı',
  timezoneUnset: 'Dağıtım varsayılanı',
  saved: 'Kaydedildi.',
  save: 'Kaydet',
  privateFieldsHint:
    'Bu dört alan özeldir — kaydınızın geri kalanını kim görebilirse görsün, bunları yalnızca siz görebilir veya değiştirebilirsiniz.',
  details: {
    title: 'Bilgiler',
    rolesTitle: 'Roller',
  },
  regionAndTimezone: {
    title: 'Bölge ve saat dilimi',
  },
  fields: {
    name: 'Ad',
    email: 'E-posta',
    nickname: 'Takma ad',
    region: 'Bölge',
    regionUnset: 'Ayarlanmadı',
    regionHint: 'İstatistiklerinizin/raporlarınızın hangi ülkeye göre yerelleştirildiği.',
    timezone: 'İstatistikler için saat dilimi',
    timezoneHint: 'İstatistik günlerinizin kapatıldığı takvim.',
    gender: 'Cinsiyet',
    birthdate: 'Doğum tarihi',
    height: 'Boy (cm)',
    weight: 'Kilo (kg)',
  },
};
